export default "__VITE_ASSET__BiigJZps__"